// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"II-z","carouselContainer":"JI-z"};